import askConsent from './consent-dialog'
import {updateConsent} from './consent'

export default () => {
  askConsent(updateConsent)
}
